export default __webpack_public_path__ + "static/kcoughlan-400ccdba5b192961a6f24db326a1943f.png";